import { Row, Col, Container, Button } from 'react-bootstrap'
import Link from 'next/link'
import Image from 'next/image'

const Work = (props) => {
  const { t, query } = props
  return (
    <div className='container-work-flirt'>
      <Container>
        <Row>
          <Col lg={1} xs={1} md={1}></Col>
          <Col lg={10} xs={10} md={10}>
            <h3 className='container-work-flirt__title'>
              {t('workbee.h3-1')} <span style={{ color: '#ec0043' }} >{t('workbee.h3-2')}</span> {t('workbee.h3-3')}
            </h3>
          </Col>
          <Col lg={1} xs={1} md={1}></Col>
        </Row>
        <div className='container-work-flirt__line'></div>
        <Row>
          <Col lg={1} xs={1} md={1}></Col>
          <Col lg={10} xs={10} md={10}>
            <div className='container-work-flirt__description'>
              <p>
                <span style={{ color: '#ec0043' }}>{t('workbee.h3-2')}</span> {t('workbee.p')}
              </p>
            </div>
          </Col>
          <Col lg={1} xs={1} md={1}></Col>
        </Row>
        <Row>
          <Col lg={12} xs={12} md={12}>
            <amp-img src={`https://flirtbees.com/images/img_3.webp`} alt="Work flirt image"
              className='container-work-flirt__image'
              layout="responsive"
              width="610" height="543" ></amp-img>
          </Col>
          <Col lg={12} xs={12} md={12}>
            <Link href={{ pathname: '/trial', query: query, shallow: true }}>
              <a className='button__free-trial btn btn-primary'>
                {t('free-trial')}
              </a>
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
export default Work
